import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import PictureWithPreload from '../PictureWithPreload.jsx';
import podcastConfig from '../../config/podcastConfig';

const mapStateToProps = state => ({
  sitePodcasts: podcastConfig[state.country],
});

@connect(mapStateToProps)
export default class FeedPicture extends React.PureComponent {

  render() {
    const { contentContainer, sitePodcasts, ...other } = this.props;

    const podcastId = _.get(contentContainer, 'tags.podcasts[0]');
    const podcast = podcastId && _.find(sitePodcasts, { id: podcastId });

    let src;
    if (podcast) {
      const fileName = podcast.images.square;
      src = require(`../../../assets/media-images/${fileName}`);
    } else {
      src = _.get(contentContainer, 'pictures[0].data.url') || _.get(contentContainer, 'videos[0].data.posterUrl');
    }

    return <PictureWithPreload src={src} alt={contentContainer.title} {...other} />;
  }
}

FeedPicture.propTypes = {
  contentContainer: React.PropTypes.object,
  sitePodcasts: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/component/NewsFeed/FeedPicture.jsx